import { Component, computed, ref } from 'vue'

type Configuration = {
  steps: Component[]
}

export const useStepper = (config: Configuration) => {
  const currentStep = ref(0)

  const next = () => {
    if (currentStep.value < config.steps.length - 1) {
      currentStep.value++
    }
  }
  const previous = () => {
    if (currentStep.value > 0) {
      currentStep.value--
    }
  }

  const setStep = (step: number) => {
    if (step >= 0 && step < config.steps.length) {
      currentStep.value = step
    }
  }

  const isLastStep = computed(() => currentStep.value === config.steps.length - 1)

  const isFirstStep = computed(() => currentStep.value === 0)
  const currentStepComponent = computed(() => config.steps[currentStep.value])

  return {
    component: currentStepComponent,
    step: currentStep,
    next,
    previous,
    setStep,
    isLastStep,
    isFirstStep
  }
}
